import { useTranslation } from 'react-i18next'
import { useField, useFormikContext } from 'formik'
import InputField from 'components/atoms/fields/InputField'
import SelectField from 'components/atoms/fields/SelectField'
import { attendanceStatusSelectData } from 'utils/helpers'
import { ISessionAttendance } from 'types'
import { FaCalendarAlt } from 'react-icons/fa'

const SessionAttendanceItemList = ({ fieldProps, title="", disabled=false }) => {
  
  const { t } = useTranslation()
  const [field] = useField<ISessionAttendance[]>(fieldProps.name)

  return (
    <>
      <div className='simple-table-wrapper'>
        <table className='checklist-table'>
          <tbody>

            {
              title && <tr>
                <th colSpan={4}>{<FaCalendarAlt />} {title}</th>
              </tr>
            }

            <tr className='checklist-table-subheading'>
              <th style={{width:'30%'}}>{t('common.students')}</th>
              <th style={{width:'20%'}}>{t('common.status')}</th>
              <th style={{width:'20%'}}>{t('common.absence-minutes')}</th>
              <th style={{width:'30%'}}>{t('common.notes')}</th>
            </tr>

              { 
                field.value.map((value: ISessionAttendance, index: number) => ( 
                  <tr key={ value.student_id }>
                    <td>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <div>
                              <div className="avatar mini" style={{ backgroundImage: 'url('+value.student_avatar+')'}} />
                            </div>
                            <div style={{ paddingLeft: "5px" }}>
                                { value.student_name }<br/>
                            </div>
                          </div>
                    </td>
                    <td>
                        {<SelectField
                            valueSelector='status'
                            fieldProps={{
                              label: t('common.status'),
                              name: `${fieldProps.name}[${index}]`,
                            }}
                            apiCall={attendanceStatusSelectData}
                            disabled={disabled}
                          />}
                      </td>
                      <td>
                        {
                          <InputField
                              valueSelector='absence_minutes'
                              fieldProps={{
                                label: t('common.absence-minutes'),
                                name: `${fieldProps.name}[${index}]`,
                              }}
                              disabled={disabled || (value.status?.id !== 'tardy' && value.status?.id !== 'tardy_excused') }
                          />
                        }                 
                      </td>
                      <td>
                        {
                          <InputField
                            multiline
                            valueSelector='comment'
                            fieldProps={{
                              label: t('common.comment'),
                              name: `${fieldProps.name}[${index}]`,
                            }}
                            disabled={disabled || !value.status?.id}
                          />
                        }

                      </td>
                    </tr>
                  ))
              }

            </tbody>
          </table> 
        </div> 
    </>
  )

}
export default SessionAttendanceItemList


